import React, {Component} from 'react';

class Feature extends Component {
    render () {

        return (
             <div className={ `feature ${this.props.classes}` }>
                <i className={ `pe-icon pe-7s-${this.props.icon}` }></i>
                <h2>{this.props.title}</h2>
                {this.props.text}
            </div>
        );
    }
}

export default Feature;


// WEBPACK FOOTER //
// ./src/components/Feature/Feature.js